import React, {useMemo} from 'react';

import moment from 'moment-tz';

import {useCurrentUserState} from 'app/current-user/api';
import {gt} from 'app/utils/i18n';

import type {
  BasicTaskUserSerializedType,
  UserSerializedType,
} from 'sweet-types';

interface Props {
  due: string;
  assignedUsers?: Array<UserSerializedType | BasicTaskUserSerializedType>;
}

export function AssigneesInOtherTimezonesWarning({
  due,
  assignedUsers = [],
}: Props) {
  const {timezone} = useCurrentUserState().data!;

  const assigneesInOtherTz = useMemo(() => {
    return assignedUsers.filter(
      (u) => u.timezone != null && u.timezone !== timezone
    );
  }, [timezone, assignedUsers]);

  return assigneesInOtherTz.length === 0 ? null : (
    <>
      {assigneesInOtherTz.map((user) => (
        <div className="form-row" key={user.url}>
          <div className="col-12">
            <div className="alert alert-info small p-2">
              {gt('%(user)s is in a different timezone.', {
                user: <b>{user.name}</b>,
              })}
              <br />
              {gt(
                'The task will be due at %(time)s their time (%(timezone)s).',
                {
                  time: <b>{moment(due).tz(user.timezone!).format('lll')}</b>,
                  timezone: user.timezone,
                }
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
